module.exports = __webpack_public_path__ + "img/U1F595.6ead8072.png";